import { Box, MenuItem, Stack } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { setSearchKeys } from "../../../lib/slices/search_key_slice";
import { getAllCompanyAppointments } from "../../../services/company/appointmentApiFn";
import { getAllWorkersByCompanyId } from "../../../services/worker/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import AddEditAppointment from "./AddEditApointmentDrawer";
import WorkerAppointmentDetail from "./AppointmentDetails";
import BlockTimeDrawer from "./BlockTimeDrawer";
import AppointmentCalendar from "./Calendar";

const CompanyWorkersShift = () => {
  const dispatch = useDispatch();
  const openBlockTimeDrawer = useRef(null);
  const openAppointmentDrawer = useRef(null);
  const openAppointmentDetailDrawer = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.userData.user);
  const [allAppointments, setAllAppointments] = useState([]);
  const [allWorkers, setAllWorkers] = useState([]);
  const [filteredWorker, setAllFilteredworker] = useState([]);
  const searchKeys = useSelector((state) => state.SearchKeysReducer.searchKeys);
  const today = moment().format("DD/MM/YYYY");

  useEffect(() => {
    if (userData) {
      fetchAllAppointments();
    }
  }, [
    userData,
    searchKeys.companyWorkername,
    searchKeys.companyAppointmentStatus,
  ]);

  useEffect(() => {
    if (userData) {
      fetchAllWorkers();
    }
  }, [userData]);

  const fetchAllAppointments = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCompanyAppointments(
        userData?.adminId,
        searchKeys.companyWorkername,
        searchKeys.companyAppointmentStatus
      );
      if (response.data.status === "success") {
        const appointmentsData = response.data.data?.map((x) => ({
          ...x,
          resourceId: x.workerId,
          start: new Date(x.start),
          end: new Date(x.end),
        }));
        setAllAppointments(appointmentsData);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllWorkers = async () => {
    try {
      const response = await getAllWorkersByCompanyId(userData?.adminId);
      if (response.data.status === "success") {
        const workersData = response.data.data.workers;
        const updated = workersData?.map((x) => ({
          ...x,
          id: x._id,
          title: x.name,
        }));
        setAllWorkers(updated);
        setAllFilteredworker(updated);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    }
  };

  // const handleOpenAppointmentDrawer = (params) => {
  //   if (params === "blocked") {
  //     openBlockTimeDrawer.current.openDrawer({ type: "add", data: null });
  //   } else {
  //     openAppointmentDrawer.current.openDrawer();
  //   }
  // };

  // Render top right part on template
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        flex={1}
        justifyContent={"flex-end"}
        alignItems={"flex-end"}
      >
        <Box>
          <Label
            labelText={t("selectWorker")}
            labelProps={{ mb: 0, fontSize: "0.75rem" }}
          />
          <CustomDropDown
            size={"small"}
            value={searchKeys.companyWorkername}
            onChange={(e) => {
              const filtered = allWorkers?.filter(
                (x) => x._id === e.target.value
              );

              if (filtered?.length > 0) {
                setAllFilteredworker(filtered);
              } else {
                setAllFilteredworker(allWorkers);
              }

              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  companyWorkername: e.target.value,
                })
              );
            }}
            formStyleProps={{
              width: { xs: "100%", md: "180px" },
            }}
          >
            <MenuItem value={"All"}>{t("all")}</MenuItem>
            {allWorkers?.map((val, ind) => {
              return (
                <MenuItem key={ind} value={val._id}>
                  {val.name}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Box>
        <Box>
          <Label
            labelText={t("selectStatus")}
            labelProps={{ mb: 0, fontSize: "0.75rem" }}
          />
          <CustomDropDown
            size={"small"}
            value={searchKeys.companyAppointmentStatus}
            onChange={(e) => {
              dispatch(
                setSearchKeys({
                  ...searchKeys,
                  companyAppointmentStatus: e.target.value,
                })
              );
            }}
            formStyleProps={{
              width: { xs: "100%", md: "180px" },
            }}
          >
            <MenuItem value={"All"}>{t("all")}</MenuItem>
            <MenuItem value={"pending"}>{t("pending")}</MenuItem>
            <MenuItem value={"accepted"}>{t("arrived")}</MenuItem>
            <MenuItem value={"started"}>{t("started")}</MenuItem>
            <MenuItem value={"completed"}>{t("completed")}</MenuItem>
          </CustomDropDown>
        </Box>
        {/* <CalendarAddMenu handleSelectType={handleOpenAppointmentDrawer} /> */}
        {/* <GlobalButton
          btnText={"Add New"}
          startIcon={<AddCircleOutlineIcon />}
          styleProps={{
            width: "auto",
            height: "45px",
          }}
        /> */}
      </Stack>
    );
  };
  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={`${t("today")} ${today}`}
        secondaryHeading={t("calendarShowAllDateTime")}
        headProps={renderRightPart()}
      >
        <AppointmentCalendar
          allWorkers={filteredWorker}
          allAppointments={allAppointments}
          handleSelectEvent={(params) =>
            openAppointmentDetailDrawer.current.openDrawer({ data: params })
          }
        />
      </AppContainer>

      {/* Open Block time drawer */}
      <BlockTimeDrawer ref={openBlockTimeDrawer} />
      {/* Add Edit appointment */}
      <AddEditAppointment ref={openAppointmentDrawer} />
      {/*Open AppointmentDetail Drawer */}
      <WorkerAppointmentDetail ref={openAppointmentDetailDrawer} />
    </NavigationDrawer>
  );
};

export default CompanyWorkersShift;
